import React, { useState } from 'react';

import { InteractivePropType } from 'propTypes/common';
import { logError } from 'utils/logger';
import ImagePreview from './components/ImagePreview';
import DivinationForm from './components/DivinationForm';
import ImageAnswer from './components/ImageAnswer';

import styles from './styles.module.scss';

const defaultAnswer = () => {
	logError("Can't find an answer");
	return {};
};
const findRandom = (list) => {
	const randomIndex = Math.floor(Math.random() * list.length);
	const randomElement = list[randomIndex];

	if (!randomElement && !randomElement.file) {
		defaultAnswer();
	}

	return randomElement;
};
const getAnswer = (results) => {
	if (!results && !results.length > 0) {
		defaultAnswer();
	}
	return findRandom(results);
};

const Divination = ({ interactive: { results, thumbnailFile } }) => {
	const [currentAnswer, setCurrentAnswer] = useState();

	const onSubmit = () => {
		setCurrentAnswer(getAnswer(results));
	};

	return (
		<div className={styles.Divination}>
			<ImagePreview {...{ thumbnailFile }} />

			<DivinationForm {...{ onSubmit }} />

			<ImageAnswer {...{ currentAnswer }} />
		</div>
	);
};

Divination.propTypes = {
	interactive: InteractivePropType
};

export default Divination;
